import { render, staticRenderFns } from "./fp-block.vue?vue&type=template&id=9a362e9e&"
import script from "./fp-block.vue?vue&type=script&lang=js&"
export * from "./fp-block.vue?vue&type=script&lang=js&"
import style0 from "./fp-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports